import { useQuery, useMutation } from 'react-query';

import { ItineraryDto, Passenger, Contact, FlightBookingGetItem } from '../flight/types';
import { QueryKeys } from '../common/types';
import { client } from '../common/services';

export type FlightApiResponse<R = Record<string, any>> = {
  body: R;
};

export type AirportAndCityData = {
  id: string;
  name: string;
  code: string;
};

export type AirportDataResponse = {
  items: AirportAndCityData[];
  count: number;
};

export type UseGetAirports = {
  lang: string;
  query: string;
  limit: number;
};
export const useGetAirportsByText = ({ query, lang = 'en', limit = 20 }: UseGetAirports) =>
  useQuery({
    enabled: !!query,
    queryKey: [QueryKeys.getAirportsByText, query, lang, limit],
    queryFn: async () => {
      try {
        const response = await client.get<AirportDataResponse>('airports/search', {
          // TODO: No se porque a nestjs no le gusta pageSize, incluso cuando
          // lo convierto a un numero explicitamente.
          params: { query, lang /* TODO: pageSize: parseInt(limit.toString(), 10)*/ },
        });

        return response;
      } catch (error) {
        console.error('error while fetching airport data:', error);
      }
    },
  });

export const useGetItineraryById = (id: number) =>
  useQuery({
    queryKey: [QueryKeys.getItineraryById, id],
    queryFn: async () => {
      try {
        const response = await client.get<ItineraryDto>(`flights/${id}`);

        return response;
      } catch (error) {
        console.error('error while fetching itinerary data:', error);
      }
    },
  });

// TODO: Implementar una vez refactor de lo de WS que tengo en availability.tsx.
// Basicamente:
// 1. Borrar todo lo que sea `sendMessage`, cambiarlo por esta query
// 2. Actualizar esta query para que reciba el payload actual que recibe sendMessage
// 3. Seguir escuchando por WS las respuestas del server
export const useGetFares = () =>
  useQuery({
    queryKey: [QueryKeys.getItineraryById],
    queryFn: async () => {
      try {
        const response = await client.get<unknown>('flights');

        return response;
      } catch (error) {
        console.error('error while fetching fare data:', error);
      }
    },
  });

export const useConfirmFareMutation = () =>
  useMutation({
    mutationFn: (fareId: number) =>
      client.post<FlightApiResponse<{ message: number }>>('flights/confirm', { id: fareId }),
    onError: (error /*, variables, context*/) => {
      console.error('error while fare confirm action:', error);
    },
  });

export type PostBookFarePayload = {
  id: number;
  passengers: Passenger[];
  contact: Contact;
};
export const useBookFareMutation = () =>
  useMutation({
    mutationFn: (data: PostBookFarePayload) => client.post<string>('flights/book', data),
    onError: (error /*, variables, context*/) => {
      console.error('error while booking fare:', error);
    },
  });

export const useGetBookingById = (id?: string) =>
  useQuery({
    queryKey: [QueryKeys.getBookingById, id],
    queryFn: async () => {
      try {
        const response = await client.get<FlightBookingGetItem>(`flights/booking/${id}`);

        return response;
      } catch (error) {
        console.error('error while fetching booking data:', error);
      }
    },
    enabled: Boolean(id),
  });

export const useGetItineraryByBookingId = (id?: string) =>
  useQuery({
    queryKey: [QueryKeys.getItineraryByBookingId, id],
    queryFn: async () => {
      try {
        const response = await client.get<ItineraryDto>(`flights/booking/${id}/itinerary`);

        return response;
      } catch (error) {
        console.error('error while fetching booking itinerary data:', error);
      }
    },
    enabled: Boolean(id),
  });
